import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  darkMode: false,
  asideShow: false,
  dataNotification : [],
  liveStreamMessage : {},
  reconnectSocket: false,
  isBlockUser: false,
  atCmd: {},
  logDevice: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggle (state, variable) {
    state[variable] = !state[variable]
  },
  setDataNotification(state, data){
    state.dataNotification = data;
  },
  setDataLiveStreamMessage(state, data){
    state.liveStreamMessage = data;
  },
  setBlockUser(state, data){
    state.isBlockUser = data;
  },
  setLogDevice(state, data){
    state.logDevice = data;
  }
}

export default new Vuex.Store({
  state,
  mutations
})
